import api from "./index";

export async function getBanners(params) {
  return api.get(`/banners`, { params });
}
